import { useContext } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "../contextProvider/ContextProvider";
import { data as en } from "./en/data";
import { data as es } from "./es/data";
import { data as ru } from "./ru/data";
import { data as zh } from "./zh/data";

/**
 * Translator engine
 * @name T
 * @param key
 * @returns {*}
 * @constructor
 */
const T = ({ key, langStr }) => {
    const { state } = useContext(GlobalContext);
    const { lang } = state || {};

    let myLang = lang || "en";
    if (!lang && langStr?.length > 0) {
        myLang = langStr;
    }
    switch (myLang) {
        case "en":
            if (en[key]) {
                return en[key];
            }
            break;
        case "es":
            if (es[key]) {
                return es[key];
            }
            break;
        case "ru":
            if (ru[key]) {
                return ru[key];
            }
            break;
        case "zh":
            if (zh[key]) {
                return zh[key];
            }
            break;
        default:
            break;
    }

    return en[key] ? en[key] : key;
};

T.propTypes = {
    key: PropTypes.string,
    langStr: PropTypes.string
};

T.defaultProps = {
    key: null,
    langStr: ""
};

export default T;
